import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import moment from 'moment'
import { MachineStateComputed } from '../../../..//models/states-computed.models'
import { TouaregControlStateHealthMonitorService } from '../../../../services/touareg-control-state-health-monitor.service'

@Component({
  selector: 'app-touareg-control-progress-countdown',
  templateUrl: './touareg-control-progress-countdown.component.html',
  styleUrls: ['./touareg-control-progress-countdown.component.scss'],
  imports: [CommonModule, TranslateModule],
})
export class TouaregControlProgressCountdownComponent
  implements OnInit, OnDestroy
{
  @Output()
  complete = new EventEmitter<boolean>()

  @Input()
  text: string | undefined

  @Input()
  set state(s: MachineStateComputed) {
    this._initState(s)
  }

  private _state: MachineStateComputed | undefined
  private _interval: any
  private _countdownMs = 0

  public countdown = 0

  constructor(private _monitor: TouaregControlStateHealthMonitorService) {}

  ngOnInit(): void {}

  private _initState(state: MachineStateComputed) {
    if (!state?.countdown || state.countdown === 0 || !state.countdown_start_date) {
      this._clear()
      return
    }

    // Si le start du countdown change,
    // On met en place un nouveau timer
    if (state?.countdown_start_date !== this._state?.countdown_start_date) {
      // On récupère les metrics
      // => offset d'horloge device/server
      // => stateUpdateScore: contient la moyenne
      // => statePureUpdateScore: contient la moyenne sans correction d'offset
      // const { dateOffset, stateUpdateScore, statePureUpdateScore } =
      //   this._monitor.health
      const { statePureUpdateScore } = this._monitor.health

      // Si la métrique n'est pas encore disponible, on ne peut pas positionner le timer
      if (!statePureUpdateScore) {
        this._clear()
        return
      }

      // On clear le timer precedent
      this._clear()

      const countdown_start_date = state.countdown_start_date.valueOf()
      const countdown_ui_end_date =
        countdown_start_date +
        statePureUpdateScore.average +
        state.countdown * 1000

      this._countdownMs = countdown_ui_end_date - moment().valueOf()
      // // Différence entre la date de calcul de l'état
      // // et la date de réception de l'état
      // let countDiff = dayjs().diff(state.countdown_start_date, 'ms')

      // // Logs
      // console.log('-----------------')
      // console.log('Initial Coundown Picture')
      // console.log('Countdown diff state update', countDiff)

      // // On ajoute (on retire de la diff) le delay moyen entre la date de cacul
      // // et la date de réception
      // if (stateUpdateScore?.average) {
      //   countDiff -= stateUpdateScore.average
      //   console.log('State update average', stateUpdateScore.average)
      //   console.log('Countdown diff MINUS state update average', countDiff)
      // }

      // // On redresse la diff par le décalage d'horloge
      // if (dateOffset) {
      //   countDiff += dateOffset
      //   console.log('Date offset', dateOffset)
      //   console.log('Countdown diff after dateOffset', countDiff)
      // }

      // // On calcule la durée UI du countdown en ms
      // this._countdownMs = state.countdown * 1000 - countDiff

      // On affiche le counddown en secondes
      this.countdown = Math.floor(this._countdownMs / 1000)

      // this._countdownDs =
      //   (state.countdown * 1000 - countDiff + dateOffset) / 100
      // // On converti l'affichage en seconde
      // this.countdown = Math.floor(this._countdownDs / 10)

      // Si on est déjà à 0, pas besoin de mettre en place le timer
      if (this._countdownMs < 0) {
        this._clear()
        return
      }

      console.log('Countdown base time', state.countdown * 1000)
      console.log('Countdown state update mean', statePureUpdateScore.average)
      console.log('Countdown MS', this._countdownMs)
      console.log('Countdown S', this.countdown)
      console.log('-----------------')

      // Mise en place du timer
      this._interval = setInterval(() => {
        this._countdownMs -= 100
        if (this._countdownMs < 0) {
          this._clear()
        } else {
          this.countdown = Math.floor(this._countdownMs / 1000)
        }
      }, 100)
    }

    this._state = state
  }

  private _clearIntervals() {
    if (this._interval) {
      clearInterval(this._interval)
      this._interval = null
    }
  }

  private _clear() {
    this._clearIntervals()
    this._countdownMs = 0
    this.countdown = 0
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this._clearIntervals()
  }
}
